export default "__VITE_ASSET__BVQPm6Bo__"